import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Select } from '@angular-redux3/store';
import { Observable, of } from 'rxjs';
import { concatMap, filter, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BusinessStatus } from '../store/entities';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  @Select(['user', 'loggedIn']) isLoggedIn$: Observable<boolean>;
  @Select(['player', 'businessStatus']) status$: Observable<BusinessStatus>;



  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    if (environment.enableDesktopMode) {
       return this.status$.pipe(
         map(status => {
        if (status?.bidStatus?.type === 'NOT_SET') {
          return this.router.navigate(['/login']) && false ;
        } else {
          return true;
        }
      }));
    }

    return this.isLoggedIn$.pipe(
      tap(isLoggedIn => !isLoggedIn && this.router.navigate(['/login']))
    );
  }
}
